import { styled } from 'styles'
import { InsurancePage } from '../components/Insurance'

function Insurance() {
  return (
    <StyledContainer>
      <InsurancePage />
    </StyledContainer>
  )
}
export const StyledContainer = styled('div', {
  'px': 25,
  'pt': 24,

  '@md': {
    px: 45,
    pt: 50,
  },
})

export const HeadingWithStatusCSS = {
  'flexWrap': 'wrap',
  'gap': '1.25rem',

  '@sm': {
    alignItems: 'center',
    justifyContent: 'space-between',
    mb: '$5',
  },
}
export const PageLayoutCss = {
  'flexWrap': 'wrap',
  'gap': '1.25rem',

  '@sm': {
    alignItems: 'center',
    justifyContent: 'end',
    mb: '$5',
  },
}
export const HeadingStatus = {
  'order': 2,
  'width': '100%',
  'mb': 0,

  '@sm': {
    order: 'initial',
    width: 'auto',
  },
}

export const StatusBar = styled('div', {
  'display': 'inline-flex',
  'alignItems': 'center',
  'background': '$blue2',
  'borderRadius': '4px',
  'padding': '.3rem .75rem',
  'mb': '1rem',

  '@sm': {
    mb: 0,
  },
})

export const Circle = styled('div', {
  'borderRadius': '50%',
  'height': '.9rem',
  'width': '.9rem',
  'marginRight': 8,

  '&.active': {
    backgroundColor: '$green1',
  },

  '&.cancelled': {
    backgroundColor: '$red',
  },

  '&.misconfigured': {
    backgroundColor: '$yellow',
  },
})

export default Insurance
